export default __webpack_public_path__ + "static/media/mad_overall.3853b3e2.png";